import React from 'react';
import { Bold, ConfirmModal } from '../../../components';
import useRemoveVehicleStakeholder from '../hooks/useRemoveVehicleStakeholder';

export default function RemoveVehicleStakeholder({ stakeholder, isOpen, toggle }) {
  const { remove, reset, loading, error } = useRemoveVehicleStakeholder({ stakeholder, onCompleted: toggle });

  return (
    <ConfirmModal
      isOpen={isOpen}
      toggle={toggle}
      title="Remove member"
      onConfirm={() => remove(stakeholder)}
      confirmButtonText="Remove Vehicle Stakeholder"
      iconColor="danger"
      confirmButtonProps={{ color: 'danger', loading, loadingText: 'Removing...' }}
      onOpened={reset}
      error={error}
    >
      Are you sure you want to remove <Bold>{stakeholder?.name}</Bold> from this vehicle? This cannot be undone.
    </ConfirmModal>
  );
}
